import { render, staticRenderFns } from "./StatsCAProgramme.vue?vue&type=template&id=123dc46b&"
import script from "./StatsCAProgramme.vue?vue&type=script&lang=js&"
export * from "./StatsCAProgramme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports